module.exports = __webpack_public_path__ + "ec5e280c8e18b26be89385de1cb1668d.svg";